var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCopy = function SvgCopy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4 11.4C2.65449 11.4 2.28174 11.4 1.98771 11.2782C1.59566 11.1158 1.28418 10.8043 1.12179 10.4123C1 10.1183 1 9.74551 1 9V3.56C1 2.66392 1 2.21587 1.17439 1.87362C1.32779 1.57256 1.57256 1.32779 1.87362 1.17439C2.21587 1 2.66392 1 3.56 1H9C9.74551 1 10.1183 1 10.4123 1.12179C10.8043 1.28418 11.1158 1.59566 11.2782 1.98771C11.4 2.28174 11.4 2.65449 11.4 3.4M9.16 17H14.44C15.3361 17 15.7841 17 16.1264 16.8256C16.4274 16.6722 16.6722 16.4274 16.8256 16.1264C17 15.7841 17 15.3361 17 14.44V9.16C17 8.26392 17 7.81587 16.8256 7.47362C16.6722 7.17256 16.4274 6.92779 16.1264 6.77439C15.7841 6.6 15.3361 6.6 14.44 6.6H9.16C8.26392 6.6 7.81587 6.6 7.47362 6.77439C7.17256 6.92779 6.92779 7.17256 6.77439 7.47362C6.6 7.81587 6.6 8.26392 6.6 9.16V14.44C6.6 15.3361 6.6 15.7841 6.77439 16.1264C6.92779 16.4274 7.17256 16.6722 7.47362 16.8256C7.81587 17 8.26392 17 9.16 17Z",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy.96ddb3e5.svg";
export { ForwardRef as ReactComponent };